<template>
    <div class="page-container">
        <div class="fixed-header">
            <Content />
        </div>
        <div class="scrollable-content">
            <HelloWorld title="Macroeconomics" background-color="#F6621F" />

            <div class="nav-container">

                <div class="nav">
                    <div class="two">
                        <div v-for="(tab, index) in tabs" :key="index" class="tab-item"
                            :class="{ active: activeTab === index }" @click="switchTab(index)"
                            @mouseenter="hoveredTab = index" @mouseleave="hoveredTab = null">
                            <span :class="{ 'tab-name': true, 'active-name': activeTab === index }">{{ tab.name
                                }}</span>
                            <div v-if="activeTab === index || hoveredTab === index" class="triangle"></div>
                        </div>
                    </div>

                </div>
            </div>




            <div class="nav-containers">
                <div class="navs">

                    <div class="nav-title">
                        <div class="nav-titles">
                            <div class="nav-title-a">
                                Difficulty
                            </div>

                            <div class="nav-title-b">All</div>

                        </div>
                        <!-- <div  class="nav-title-b">All</div> -->
                        <div class="nav-title-c">least difficulty</div>
                        <div class="nav-title-c">mediumdifficulty</div>
                        <div class="nav-title-c">high difficulty</div>
                    </div>

                </div>
            </div>
            <middlePdf />

            <!-- <div class="nav-container-s">
                <div class="nav">
                    <div class="box-row-f">
                        <div v-for="(item, index) in 10" :key="item" class="box1-wrapper3" @click="goToDetail">
                            <div class="box-left">
                                <img src="../assets/images/tiku-img.png" alt="">
                            </div>
                            <div class="box-right">
                                <div class="box-text-top">
                                    This is the titleofthequestionbank
                                    <br />
                                    This is the title of the
                                </div>
                                <div class="box-text-bottom">
                                    <text>
                                        Viewdetails
                                    </text>
                                    <img src="../assets/images/Vector.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="logo-a-g">
                        <Arrowhead />
                    </div>
                </div>
            </div> -->
        </div>
        <div class="fixed-footer">
            <Concat />
        </div>
    </div>

</template>

<script setup>
import middlePdf from '../pages/middle-pdf.vue'
// import HelloWorld from '@/components/HelloWorld.vue';
// import Arrowhead from '../components/Arrowhead.vue'
import { useRouter } from 'vue-router';
import Concat from '../components/Concat.vue'
import Content from '../components/Content.vue'
import HelloWorld from '@/components/HelloWorld.vue';
// import { computed } from 'vue';
const router = useRouter();

import { ref, onMounted } from 'vue'

// 当前激活的 tab
const activeTab = ref(0)

//当前悬停的tab
const hoveredTab = ref(null)
// 定义 tabs
const tabs = ref([
    { name: 'Past year papers', path: '/microeconomics' }, // 修改为跳转到 /microeconomics
    { name: 'Difficulty', path: '/microeconomics' },           // 保持跳转到 /difficulty
    { name: 'Knowledge points', path: '/physics1' },
    { name: 'Video & Notes', path: '/physics1' }          // 修改为跳转到 /physics1
])






function goToDetail() {
    router.push({ path: "/Detail-pdf" });
}
</script>

<style lang="scss" scoped>
.page-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.fixed-header {
    flex-shrink: 0;
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    max-height: 1732px;
}

.fixed-footer {
    flex-shrink: 0;
}



/* 2222222 */
.nav-container {
    width: 100vw;
    display: flex;
    justify-content: center;



    .nav {
        width: 1200px;
        margin: 0px 120px 0px 120px;
    }
}

.two {
    width: 100%;
    height: 64px;
    background: #000000;
    border-radius: 0px 0px 0px 0px;
    display: flex;

    .tab-item {
        margin: 20px 0px 19px 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
        text-align: left;
        cursor: pointer;
        padding: 0 10px;
        transition: all 0.3s ease;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .tab-item:first-child {
        margin-left: 24px;
    }

    .tab-item:not(:first-child) {
        margin-left: 155px;
    }

    .tab-item:hover {
        opacity: 0.8;

    }

    .tab-name {
        white-space: nowrap;
    }

    .tab-name.active-name {
        font-weight: 800;
    }




    .triangle {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 10px solid white;
        margin-top: 8px;
    }
}

// @import '../pages/index-m.css'</style>